module.exports = __webpack_public_path__ + "img/Slika3_2021.4e2c2a8f.png";